module.exports = __webpack_public_path__ + "img/nav-designer@2x.f6cfe01.jpg";